module.exports = __webpack_public_path__ + "img/心悦容（医生办院）.b9d512b.png";